import { Component, OnInit, Inject } from '@angular/core';
import { SharingDataService } from 'src/app/Services/sharing-data.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateResourceDefinitionPipe } from 'src/app/shared/pipes/translateResourceDefinition.pipe';

@Component({
  selector: 'app-confirmationWindow',
  templateUrl: './confirmationWindow.component.html',
  styleUrls: ['./confirmationWindow.component.css']
})
export class ConfirmationWindow {
  resourceDefinition;
  Title: string;
  Text: string;

  constructor(
    private shareData: SharingDataService,
    public dialogRef: MatDialogRef<ConfirmationWindow>,
    public translateResourceDefinition: TranslateResourceDefinitionPipe,
    @Inject(MAT_DIALOG_DATA) public InputData
  ) { 
    shareData.currentResourceDefinition.subscribe(data => this.resourceDefinition = data);
    this.replacePlaceholders();
  }
  groupName = "Common";

  replacePlaceholders(){
    this.Title = this.translateResourceDefinition.transform(this.InputData.Title, this.resourceDefinition, "KEY_NAME", "LONG_TEXT", this.groupName);
    this.Text = this.translateResourceDefinition.transform(this.InputData.Text, this.resourceDefinition, "KEY_NAME", "LONG_TEXT", this.groupName);
    for(let i = 0; i < this.InputData.Placeholders?.length; i++){
      this.Title = this.Title.replace(`{${i}}`, this.InputData.Placeholders[i]);
      this.Text = this.Text.replace(`{${i}}`, this.InputData.Placeholders[i]);
    }
  }
}